import { useUserStore as usePriceUserStore } from '@wegic/price-ui';
import { updateUserPointsData } from '@/helpers/user';
import { getUserPoints, refreshUserCoupons } from '@/services/pay';
import { getUserSubscriptionRequest } from '@/services/user';
import { useUserStore } from '@/stores/user';

/**
 * 获取用户订阅和积分信息
 */
export async function handleSubscriptionAndPointsAPI() {
  try {
    const [subscriptionRes, pointsRes] = await Promise.all([
      getUserSubscriptionRequest().catch(() => null),
      getUserPoints().catch(() => null),
    ]);

    if (pointsRes?.data) {
      updateUserPointsData(pointsRes.data);
    }

    const latestSubscription = subscriptionRes?.code === 0 ? subscriptionRes.data : null;
    if (latestSubscription) {
      useUserStore.getState().setUserSubscription(latestSubscription);
      usePriceUserStore.getState().setUserSubscription(latestSubscription);
    }

    await refreshUserCoupons();

    return {
      subscription: subscriptionRes?.data,
      points: pointsRes?.data,
    };
  } catch (error) {
    console.error('Failed to fetch subscription and points:', error);
    return null;
  }
}
